import CustomIcon from 'gyl-common/components/CustomIcon'

export default CustomIcon
